const SELECTOR = '[data-component-dynamic]';

function cloneTemplate(template, name) {
  const index = new Date().getTime();
  const $clonedTemplate = $(template.replaceAll('NEW_RECORD_INDEX', index));

  $clonedTemplate
    .find('[data-dynamic-remove]')
    .each((_, el) => $(el).attr('data-dynamic-target', `[data-dynamic-name=${name}][data-dynamic-index=${index}]`));

  return $clonedTemplate;
}

function initDynamicFields(element) {
  const template = element.dataset['componentDynamic'];
  const { id } = element;
  const name = id.replace(/^dynamic_/, '');
  const $addButton = $(`button[data-dynamic-add=${name}]`);

  element.setAttribute('data-component-dynamic', '');

  // Add target for remove buttons
  $(`[data-dynamic-name=${name}]`).each((index, fields) => {
    $(fields)
      .find('[data-dynamic-remove]')
      .each((_, el) => $(el).attr('data-dynamic-target', `[data-dynamic-name=${name}][data-dynamic-index=${index}]`));
  });

  const addFields = () => {
    const $fields = cloneTemplate(template, name);
    $fields.insertBefore(element).trigger('dom-update', { source: 'dynamic-fields' });
    $fields.get(0).dispatchEvent(new CustomEvent('dynamic:addedFields'));
  };

  $addButton.on('click', addFields);
}

$(document).on('click', '[data-dynamic-remove=destroy]', e => {
  const $fields = $(e.target.dataset['dynamicTarget']);

  $fields.find('input[name$="[_destroy]"]').val('true');
  $fields.find('[required]').removeAttr('required');
  $fields.hide().addClass('deleted');
  $fields.get(0).dispatchEvent(new CustomEvent('dynamic:deletedFields'));
});

$(document).on('click', '[data-dynamic-remove=remove]', e => {
  const $target = $(e.target.dataset['dynamicTarget']);

  // First disable all form controls to trigger event over it an then remove element
  $target.find(':input').prop('disabled', true);
  $target.get(0).dispatchEvent(new CustomEvent('dynamic:deletedFields'));

  $target.remove();
});

$(document).on('dom-update', e => {
  $(e.target)
    .find(SELECTOR)
    .each((_, element) => initDynamicFields(element));
});
